import type { ReactNode } from 'react';

/** `**texto**` → `<b>texto</b>`. Só negrito, sem nesting: o suficiente para a
 *  ênfase das copies de card sem uma dependência de markdown. A key de cada
 *  `<b>` é a posição do trecho no texto; o texto solto entre eles não precisa. */
export function withBold(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let rest = 0;
  for (const match of text.matchAll(/\*\*(.+?)\*\*/g)) {
    nodes.push(text.slice(rest, match.index), <b key={match.index}>{match[1]}</b>);
    rest = match.index + match[0].length;
  }
  nodes.push(text.slice(rest));
  return nodes;
}
